export default __webpack_public_path__ + "static/media/seebeck_logo_white.ca316c8b.svg";